import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, hasOne, options } from '@apexdesigner/schema-tools';

export const testArticle = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    type: options([
      { value: 'Test In', name: 'Test In' },
      { value: 'Test In Verification', name: 'Test In Verification' },
      { value: 'Test Out', name: 'Test Out' },
      { value: 'Test Out Verification', name: 'Test Out Verification' },
    ])
      .nullable()
      .optional()
      .describe('Type'),

    oralReadingFluency: options([
      { value: '0.0', name: '0.0' },
      { value: '0.5', name: '0.5' },
      { value: '0.8', name: '0.8' },
      { value: '1.0', name: '1.0' },
      { value: '1.3', name: '1.3' },
      { value: '1.5', name: '1.5' },
      { value: '1.8', name: '1.8' },
      { value: '2.0', name: '2.0' },
      { value: '2.5', name: '2.5' },
      { value: '3.0', name: '3.0' },
      { value: '3.5', name: '3.5' },
      { value: '4.0', name: '4.0' },
      { value: '4.5', name: '4.5' },
      { value: '5.0', name: '5.0' },
      { value: '5.5', name: '5.5' },
      { value: '5.6', name: '5.6' },
      { value: '6.0', name: '6.0' },
      { value: '6.5', name: '6.5' },
      { value: '7.0', name: '7.0' },
      { value: '7.5', name: '7.5' },
      { value: '8.0', name: '8.0' },
      { value: '8.5', name: '8.5' },
      { value: '9.0', name: '9.0' },
      { value: '9.5', name: '9.5' },
      { value: '10.0', name: '10.0' },
      { value: '10.5', name: '10.5' },
      { value: '11.0', name: '11.0' },
      { value: '11.5', name: '11.5' },
      { value: '12.0', name: '12.0' },
      { value: 'Adult', name: 'Adult' },
    ])
      .nullable()
      .optional()
      .describe('Oral Reading Fluency'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    pdfDocument: hasOne('PdfDocument'),

    workingTestResults: hasMany('TestResult', 'workingArticleId'),

    achievedTestResults: hasMany('TestResult', 'achievedArticleId'),
  })
  .describe('A reading passage used in assessments.')
  .as('TestArticle');

export { testArticle as testArticleSchema };
